













































import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import MultiLabelHistogram from '@/trials/views/components/MultiLabelHistogram.vue';
import MultiLabelBarChart from '@/trials/views/components/MultiLabelBarChart.vue';
import TrainColumn from '@/trials/domain/objects/trainColumn';

@Component({ components: { MultiLabelHistogram, MultiLabelBarChart } })
export default class TrainDataStatisticsLabels extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/

    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private inputTypeNumber: string = SC.InputData.Type.NUMBER;
    private labelName: string = '';
    private trainDataStatistics: TrainColumn[] = [];

    /*----------------------------------*
     * Computed
     *-----------------------------------*/

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        // label以外のデータにする
        const columns: TrainColumn[] = sessionModule.getTrainDataStatistics;
        this.trainDataStatistics = columns.filter((column: TrainColumn) => {
            return !column.isLabel;
        });
    }

    mounted() {
        // ラベル行に設定されたカラム名を保持
        this.labelName = sessionModule.getTrainingData.labelName;
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
}
